export default __webpack_public_path__ + "static/media/stamp3.8a0cd826.png";